// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"236":"5a4dc29d","281":"674458a1","674":"118c15a0","842":"f6321807","847":"9a827420"}[chunkId] + ".css";
};